(function ($, window) {
  const pluginName = 'productCompare',
    publicMethods = ['resetPanel'];
  $.fn.productCompare = function (options) {
    const args = arguments;
    const dataAttr = `plugin_${pluginName}`;
    return this.each(function (index, element) {
      if (typeof options === 'string') {
        if (publicMethods.indexOf(options) > -1) {
          const productCompare = $.data(element, dataAttr),
            method = options;
          productCompare[method].apply(productCompare, Array.prototype.slice.call(args, 1));
        } else {
          throw new SyntaxError(`Invalid method "${options}"`);
        }
      } else if (!$.data(this, dataAttr)) {
        const productCompare = Object.create(ProductCompare);
        productCompare.init(options, element);
        $.data(this, dataAttr, productCompare);
      }
      return this;
    });
  };
  $.fn.productCompare.options = {
    $compareModal: undefined,
    // The search bar that is being targeted
    $comparePanel: undefined,
    $compareTable: undefined,
    $compareBtn: undefined,
    list: [],
    tableHTml: undefined
  };
  let ProductCompare = {
    // Initialize the ProductCompare module by attaching any events
    // that we need to run an autocomplete.
    init: function (options, element) {
      const self = this;
      self.options = $.extend({}, $.fn.productCompare.options, options);
      self.element = element;
      self.options.$compareModal = $('#compare-select');
      self.options.$comparePanel = $('.compare-panel');
      self.options.$compareTable = $('.compare-table');
      self.options.tableHTml = self.options.$compareTable.clone().html();
      self.initEvents();
    },
    //Initializes the events
    initEvents: function () {
      const self = this;

      //Clicking the X next to the selected product in the panel
      $(document).on('click', '.compare-panel__prod-remove', function (e) {
        let productID = $(e.currentTarget).parents('.compare-panel__prod').attr('id');
        self.removeItemFromPanel(productID);
      });

      // When you click the link on the listing product to compare
      $(document).on('change', '.compare__add', function () {
        let product = $(this);
        if (self.options.list.length === 3) {
          $('.product-listing-container').find('.compare__add:checkbox:not(:checked)').attr('disabled', 'disabled');
        } else if (self.options.list.length === 4) {
          $('.product-listing-container').find('.compare__add:checkbox:not(:checked)').removeAttr('disabled');
        }
        self.addProductToPanel(product);
      });

      //When you click the compare button in the compare panel
      $(document).on('click', '.compare-panel__btn--comp', function (e) {
        $(e.currentTarget).removeClass('active').attr('disabled', '');
        self.getSpecs(self.options.list);
      });

      //When you click the clear button in the compare panel
      $(document).on('click', '.compare-panel__btn--clear', function () {
        self.resetPanel();
      });

      // Resets (unchecks) any checkboxes after leaving and then returning to the page
      $(window).on('load', function (event) {
        $('.prod .compare__add:checked').prop('checked', false);
      });

      // When you click remove a product in the table
      $(document).on('click', '.compare-table__prod-remove', function () {
        self.removeItemFromTable($(this).parent(), $(this).parent().data('nth'));
      });
      $(document).on('change', '.compare-table .form-check-input', function (e) {
        let isChecked = $(this).is(':checked'),
          visibility;
        isChecked ? visibility = 'hide' : visibility = 'show';
        self.showDifferencesOnly(visibility);
      });

      //When the bootstrap Modal is closed.
      self.options.$compareModal[0].addEventListener('hide.bs.modal', () => {
        self.reset($(this));
      });

      //When the modal is shown, hide the panel
      self.options.$compareModal[0].addEventListener('shown.bs.modal', () => {
        $('.compare-panel').addClass('hide');
      });
    },
    // Gets the json data. Passes in the sku list.
    getSpecs: function (skuList) {
      const self = this,
        skuIds = skuList.join(',');
      $.ajax({
        url: `/product/comparison.json?skuIds=${skuIds}`,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        data: self.options.list
      }).done(function (data) {
        /* Separate out the spec list and the prod list
        and pass both to the populate function */
        let reqSpecList = data.reqSpecs,
          nonReqSpecList = data.nonReqSpecs,
          productList = data.products;
        self.populateCompareTable(reqSpecList, nonReqSpecList, productList);
      });
    },
    /* When the user hits the compare link on the listed product,
     ** it adds it to the panel below.*/

    addProductToPanel: function (item) {
      const self = this;
      let parent = item.parents('.prod'),
        productID = parent.attr('data-sku-id');

      //Show the compare panel
      self.options.$comparePanel.removeClass('hide');
      let inArray = $.inArray(productID, self.options.list);
      if (inArray < 0) {
        if (self.options.list.length < 4) {
          // Selected class adds a way to see which products are selected
          parent.toggleClass('compare--selected');

          //As long as there are 4 or less products, add the sku id to the array
          self.options.list.push(productID);
          let displayTitle = parent.find('.prod__name__display').text(),
            image = parent.find('.prod__img img').attr('src');
          $('.compare-panel__body .compare-panel__default:first').replaceWith(`<div id="${productID}" class="compare-panel__prod">
							<div class="compare-panel__prod-card card">
								<button type="button" class="compare-panel__prod-remove"
								aria-label="Close"></button>
								<div class="compare-panel__prod-content">
									<div class="compare-panel__prod-img">
										<img src="${image}" alt="image" class="compare-panel__cp-img"/>
									</div>
									<div class="compare-panel__prod-body">${displayTitle}</div>
								</div>
							</div>
						</div>`);
        } else {
          /* If they've already selected 4 products, don't allow them to select any more */
          return;
        }
      } else {
        //If it's already in the array and they clicked on it again, remove it from the panel
        self.removeItemFromPanel(productID);
      }

      // Don't let the compare button in the panel be clickable
      // until they have at least 2 items selected.
      self.options.list.length > 1 ? $('.compare-panel__btn--comp').addClass('active').removeAttr('disabled') : $('.compare-panel__btn--comp').removeClass('active').attr('disabled', '');

      // If there are 4 items in the panel, show the "4 items max" text
      self.options.list.length === 4 ? $('.compare-panel__max-item').removeClass('hid') : $('.compare-panel__max-item').addClass('hid');
    },
    populateCompareTable: function (reqSpecList, nonReqSpecList, productList) {
      const self = this;

      //Create Table Rows with header (attribute text to the left)
      $.each(reqSpecList, function (i, item) {
        let tableRow = `<div class="compare-table__attr-row">
						<div class="compare-table__attr-value compare-table__attr-header">${item}</div>
					</div>`;
        self.options.$compareTable.find('.compare-table__body').append(tableRow);
      });
      $.each(nonReqSpecList, function (i, item) {
        let tableRow = `<div class="compare-table__attr-row">
						<div class="compare-table__attr-value compare-table__attr-header">${item}</div>
					</div>`;
        self.options.$compareTable.find('.compare-table__body').append(tableRow);
      });

      //For each product that's chosen for comparison,
      // Go through all the information in the object
      for (let i = 0; i < productList.length; i++) {
        // Get a products img src
        let imgUrl = productList.map(x => x.image_url)[i],
          // get products name
          productName = productList.map(x => x.name)[i],
          // Get products sku id
          skuId = productList.map(x => x.sku_id)[i],
          // Get the list of attributes
          attributes = productList.map(x => x.attributes)[i],
          //Create the add to cart URL
          addToCartUrl = `/cart/add?skuId=${skuId}&quantity=1`;

        // Create the product image and title HTML to go above the table
        let itemHtml = `<div class="compare-table__attr-product" data-nth="${[i + 1]}">
						<div role="button" class="compare-table__prod-remove"
						aria-label="Close"></div>
						<img class="compare-table__prod__img" src="${imgUrl}" width="100">
						<div data-prod-sku="${skuId}" class="compare-table__prod-name">
						${productName}</div>
						<div class="compare-table__prod-add">
							<a class="compare-table__prod__btn btn btn-outline-primary btn-sm"
							href="${addToCartUrl}">Add to Cart</a>
						</div>
					</div>`;

        // Append that product image/title HTML
        self.options.$compareTable.find('.compare-table__head').append(itemHtml);
        //Iterate through all the attributes found previously
        $.each(attributes, function (key, value) {
          // From the previous appended attributes, find the one that matches with this key.
          let currentAttribute = $('.compare-table__body .compare-table__attr-header').filter(function () {
            return $(this).text() === key;
          });
          /** Sometimes the attribute has multiple values that are put in an array.
           ** If it's an array, iterate through that and wrap each element in a div
           ** then put those elements inside of a data cell and append that to
           ** the corresponding attribute's table row
           ** If it's NOT an array, wrap it in a data cell and append it to the
           ** corresponding attribute's table row */
          if (Array.isArray(value)) {
            let elements = $();
            for (let x = 0; x < value.length; x++) {
              elements = elements.add(`<div>${value[x]}</div>`);
            }
            let td = $("<div class='compare-table__attr-value'></div>").html(elements);
            currentAttribute.parent().append(td);
            elements = $();
          } else {
            //If it has a true or false value, then use a check mark or an Xmark
            if (value === 'true') {
              currentAttribute.parent().append(`<div class='compare-table__attr-value'>Yes</div>`);
            } else if (value === 'false') {
              currentAttribute.parent().append(`<div class='compare-table__attr-value'>No</div>`);
            } else {
              currentAttribute.parent().append(`<div class='compare-table__attr-value'>${value}</div>`);
            }
          }
        });
      }

      //Pop the modal
      new bootstrap.Modal(self.options.$compareModal[0]).show();
    },
    removeItemFromTable: function (product, index) {
      const self = this;
      let skuId = product.find('[data-prod-sku]').data('prodSku'),
        siblings = product.siblings(),
        numberOfProducts = $('.compare-table__attr-product[data-nth]').length;

      /* The Nth value changes when one is removed so we need to
       ** reassign in order to remove the correct attribute values.
       ** -- kinda ugly but tables suck */
      self._reassignNth(siblings);
      product.remove();

      /** Instead of using the self.options.list, we're using the number of
       ** products because for some reason there's a timing issue with removing
       ** a product from the list array and if the timing is off the modal will
       ** sometimes not close. Using number of products takes away that timing issue
       **/
      if (numberOfProducts <= 2) {
        self.options.$compareModal.find('.btn-close').trigger('click');
        // bootstrap.Modal.getInstance(self.options.$compareModal[0]).hide();
      } else {
        $('.compare-table__body').children().each(function (i) {
          $(this).find(`.compare-table__attr-value:eq(${index})`).remove();
        });
      }

      //Remove from the compare panel
      self.removeItemFromPanel(skuId);
    },
    //Hides the panel where the products show up at the bottom
    hideComparePanel: function () {
      const self = this;
      $('.compare-panel__prod').replaceWith('<div class="compare-panel__default"></div>');
      self.options.$comparePanel.addClass('hide');
    },
    //Removes an item from the compare panel
    removeItemFromPanel: function (productID) {
      const self = this;
      const placeholder = '<div class="compare-panel__default"></div>';
      //Remove the product from the list array
      self._removeFromListArray(productID);
      // Find the actual product list product and remove the selected class
      let prod = $(`.prod[data-sku-id="${productID}"] .compare__add`);
      prod.prop('checked', false);
      // Remove product content from panel
      $(`#${productID}`).remove();
      //Append to the end so the products are always next to eachother
      $('.compare-panel__body').append(placeholder);

      /* When removing a product, we assume there are less than 4 selected so if any add to
       ** compare checkboxes were disabled, reenable them */
      if ($('.product-listing-container .compare__add:disabled')) {
        $('.product-listing-container').find('.compare__add:checkbox:not(:checked)').removeAttr('disabled');
      }

      /* If there's at least two products and then all but one is removed, disable compare button. Else if it's the last ** product you're removing, then close the panel */
      if (self.options.list.length === 1) {
        $('.compare-panel__btn--comp').removeClass('active').attr('disabled', '');
      } else if (!self.options.list.length) {
        self.hideComparePanel();
      }
    },
    // Empties the modal's content when the modal is closed
    // Avoids duplicate content
    // This isn't the most elegant way to do it but every way had it's drawbacks.
    reset: function () {
      const self = this;
      self.options.$compareTable.empty().append(self.options.tableHTml);
      // Empty the list array
      self.options.list = [];
      // If the add to compare checkbox is checked, uncheck it
      $('.prod .compare__add:checked').prop('checked', false);
      // If the add to compare checkbox is disabled, enable it
      $('.prod .compare__add:disabled').removeAttr('disabled');
      $('.compare-panel__prod').replaceWith('<div class="compare-panel__default"></div>');
    },
    resetPanel: function () {
      const self = this;
      self.reset();
      self.hideComparePanel();
    },
    /* If you hit the checkbox that says 'differences only', it hides or shows the
     ** rows who's content is all the same. */
    showDifferencesOnly: function (visibility) {
      const self = this;
      let rows = this.options.$compareTable.find('.compare-table__attr-row');
      if (visibility === 'hide') {
        rows.each(function (i, e) {
          let tableCells = $(e).children(':not(.compare-table__attr-header)');
          let tableCellArray = [];
          tableCells.each(function (i, e) {
            tableCellArray.push($(e).text());
          });
          if (tableCellArray.every((val, i, arr) => val === arr[0])) {
            $(e).hide();
          }
        });
        self.reZebra(rows);
      } else {
        rows.show();
        self.reZebra(rows);
      }
    },
    /* To maintain correct zebra striping, reapply styles when rows are hidden or shown. */
    reZebra: function (rows) {
      let zebraRows = this.options.$compareTable.find('.compare-table__attr-row:nth-of-type(2n)');
      rows.css('background', 'white');
      zebraRows.css('background', '#f4f6f8');
    },
    _reassignNth: function (siblings) {
      siblings.each(function (i) {
        $(this).attr('data-nth', i);
      });
    },
    //Removes a value from the list array
    _removeFromListArray: function (skuId) {
      const self = this;
      self.options.list.splice($.inArray(skuId, self.options.list), 1);
    }
  };
})(jQuery, window);

//Initialize the plugin on the document.
$(document).productCompare();